import getAdminData from './getAdminData'
export const getAdminDataService = getAdminData;